export const environment = {
  production: true
};

export const restroot = 'https://hidden-shelf-50024.herokuapp.com/';



// WEBPACK FOOTER //
// ./src/environments/environment.ts